import React from 'react';
import { string, number } from 'prop-types';
import { colorsV1 } from '@ajaibid/components'

const ChevronDropRight = ({ width, height, color }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66732 3.66667C6.66732 3.29848 6.36884 3 6.00065 3C5.63246 3 5.33398 3.29848 5.33398 3.66667V9.66667C5.33398 10.0349 5.63246 10.3333 6.00065 10.3333H9.88453L8.82783 11.5662C8.58821 11.8457 8.62059 12.2666 8.90014 12.5062C9.17969 12.7458 9.60055 12.7134 9.84017 12.4339L11.8402 10.1005C12.0542 9.85088 12.0542 9.48248 11.8402 9.23282L9.84017 6.89948C9.60055 6.61993 9.17969 6.58756 8.90014 6.82717C8.62059 7.06679 8.58821 7.48766 8.82783 7.76721L9.88451 9H6.66732V3.66667Z"
      fill={color}
    />
  </svg>
);

ChevronDropRight.propTypes = {
  color: string,
  width: number,
  height: number
};

ChevronDropRight.defaultProps = {
  color: colorsV1.MARKET_COLOR_BASE,
  width: 16,
  height: 16
};

export default ChevronDropRight;
